import type { NotificationDestination } from "../types/index.js";
import { NotificationTarget, NotificationType, notificationMetadataSchema } from "../types/index.js";

export function getNotificationDestination(type: NotificationType, metadata: unknown): NotificationDestination | null {
	const parsed = notificationMetadataSchema.safeParse(metadata ?? {});
	const data = parsed.success ? parsed.data : {};

	switch (type) {
		case NotificationType.POST_LIKED:
		case NotificationType.POST_COMMENTED:
		case NotificationType.POST_MENTION:
		case NotificationType.POST_REPORTED:
		case NotificationType.POST_DELETED_BY_MOD:
		case NotificationType.COMMENT_LIKED:
		case NotificationType.COMMENT_REPLIED:
		case NotificationType.COMMENT_REPORTED:
		case NotificationType.COMMENT_DELETED_BY_MOD:
		case NotificationType.JOIN_APPROVED:
		case NotificationType.JOIN_REJECTED:
			return { target: NotificationTarget.FEED };

		case NotificationType.MEETING_INVITATION:
		case NotificationType.MEETING_CANCELLED:
		case NotificationType.MEETING_UPDATED:
		case NotificationType.MEETING_REMINDER:
		case NotificationType.MEETING_RESCHEDULE_REQUEST:
			if (data.meeting_id) {
				return { target: NotificationTarget.MEETING_DETAIL, meetingId: data.meeting_id };
			}
			return { target: NotificationTarget.MEETING_LIST };

		case NotificationType.MEMBER_JOINED:
		case NotificationType.MEMBER_REPORTED:
		case NotificationType.MEMBER_BANNED:
		case NotificationType.JOIN_REQUEST:
			return { target: NotificationTarget.MEMBER_LIST };

		case NotificationType.EVENT_INVITED:
		case NotificationType.EVENT_CANCELLED:
		case NotificationType.EVENT_UPDATED:
		case NotificationType.WAITLIST_AVAILABLE:
			return { target: NotificationTarget.EVENT_LIST };

		case NotificationType.GROUP_JOIN_REQUEST:
			return { target: NotificationTarget.ADMIN_GROUP_LIST };

		case NotificationType.GROUP_JOIN_APPROVED:
		case NotificationType.GROUP_JOIN_DENIED:
			return { target: NotificationTarget.GROUP_LIST };

		default:
			return null;
	}
}
